/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Presence } from '../../models/presence';

export interface FindPresences$Params {
  resourceIds: Array<string>;
  dateFrom: string;

/**
 * If omitted, defaults to fromDate + 1 month. If provided, range will be limited to max. 2 months from fromDate
 */
  dateTo?: string;
  presenceTypeIds?: Array<string>;
}

export function findPresences(http: HttpClient, rootUrl: string, params: FindPresences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Presence>>> {
  const rb = new RequestBuilder(rootUrl, findPresences.PATH, 'get');
  if (params) {
    rb.query('resourceIds', params.resourceIds, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('presenceTypeIds', params.presenceTypeIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Presence>>;
    })
  );
}

findPresences.PATH = '/api/agn-presences';
